import {
    PRODUCTION_REGISTER_YARN_REPORT_REQUEST,
    PRODUCTION_REGISTER_YARN_REPORT_SUCCESS,
    PRODUCTION_REGISTER_YARN_REPORT_FAILURE,
    PRODUCTION_REGISTER_YARN_FILTER_REPORT_REQUEST,
    PRODUCTION_REGISTER_YARN_FILTER_REPORT_SUCCESS,
    PRODUCTION_REGISTER_YARN_FILTER_REPORT_FAILURE
  } from "../types/production-register-yarn-report-types";
  
  const initialState = {
    productionYarnReports: {},
    loading: false,
    error: null,
  };
  
  const productionYarnReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PRODUCTION_REGISTER_YARN_REPORT_REQUEST, PRODUCTION_REGISTER_YARN_FILTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PRODUCTION_REGISTER_YARN_REPORT_SUCCESS: {
        return {
          ...state,
          productionRegisterYarnReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PRODUCTION_REGISTER_YARN_FILTER_REPORT_SUCCESS: {
        return {
          ...state,
          productionRegisterYarnFilterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PRODUCTION_REGISTER_YARN_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default productionYarnReportReducer;
  